module.exports = __webpack_public_path__ + "img/foodworks-logo.bad073d0.png";